import React, { useContext } from "react"
import type { MenuRenderTriggerApi } from "@mallardbay/lib-react-components"
import {
    Avatar,
    Menu,
    componentStyles,
    useColors,
} from "@mallardbay/lib-react-components"

import { UserContext } from "~contexts/user-provider"
import { TEST_IDS } from "~config/constants"
import useProfileMenuConfig from "~components/shared/header/use-profile-menu-config"

const TRIGGER_STYLES: React.CSSProperties = {
    cursor: "pointer",
    borderRadius: "9999px",
    display: "inline-flex",
    border: "none",
    background: "transparent",
    padding: 0,
}

export default function ProfileButton() {
    const styles = useStyles()
    const { user, isLoading, isImpersonating } = useContext(UserContext)
    const { menuItems, impersonationModal } = useProfileMenuConfig()

    const renderTrigger = ({ getTriggerProps }: MenuRenderTriggerApi) => {
        const tp = getTriggerProps()

        return (
            <div
                ref={tp.ref}
                id={tp.id}
                role={tp.role}
                tabIndex={tp.tabIndex}
                aria-haspopup={tp["aria-haspopup"]}
                aria-expanded={tp["aria-expanded"]}
                aria-controls={tp["aria-controls"]}
                onClick={tp.onClick}
                onKeyDown={tp.onKeyDown}
                data-testid={TEST_IDS.PROFILE_BUTTON}
                style={TRIGGER_STYLES}
            >
                <Avatar
                    size="sm"
                    name={`${user?.first_name} ${user?.last_name}`}
                    src={user?.avatar_url || ""}
                    testId={
                        isImpersonating
                            ? TEST_IDS.PROFILE_BUTTON_IMPERSONATING_AVATAR_INDICATOR
                            : undefined
                    }
                    style={
                        isImpersonating ? styles.impersonatingAvatar : undefined
                    }
                />
            </div>
        )
    }

    return (
        <>
            <Menu
                menuItems={menuItems}
                isLoading={isLoading}
                placement="bottom-end"
                renderTrigger={renderTrigger}
            />
            {impersonationModal}
        </>
    )
}

function useStyles() {
    const colors = useColors()

    return componentStyles({
        impersonatingAvatar: {
            ring: 2,
            ringColor: colors.warning,
        },
    })
}
